import api from './api'
import apiAsync from './apiAsync'
import client from './client'
import install from './install'

export default class JindashiApi {
  constructor (options) {
    if (JindashiApi.instance) {
      throw new Error('JindashiApi is singleton')
    }
    JindashiApi.instance = this
    this.options = options
    client.defaults.baseURL = options.baseURL

    this.api = api
    this.apiAsync = apiAsync
  }

  static getInstance () {
    return JindashiApi.instance
  }
}

JindashiApi.instance = null
JindashiApi.install = install



// WEBPACK FOOTER //
// ./src/apis/jindashi-api/index.js